import React from 'react';
import { Lead, EligibilityStatus } from '../types';
import { Badge } from './ui/Badge';
import { Button } from './ui/Button';
import { EyeIcon, XCircleIcon } from 'lucide-react';
import { formatTimeAgo } from '../utils/time';
interface CancelledLeadsTableProps {
  leads: Lead[];
  onViewDetails: (lead: Lead, eligibility: EligibilityStatus) => void;
  onAction: (leadId: string, action: 'send' | 'cancel') => void;
}
export function CancelledLeadsTable({
  leads,
  onViewDetails,
  onAction
}: CancelledLeadsTableProps) {
  if (leads.length === 0) {
    return <div className="p-8 text-center" data-id="element-1">
        <p className="text-sm text-gray-500" data-id="element-2">
          No cancelled leads during this window.
        </p>
      </div>;
  }
  return <div className="overflow-x-auto" data-id="element-3">
      <table className="min-w-full divide-y divide-gray-200" data-id="element-4">
        <thead className="bg-gray-50/50" data-id="element-5">
          <tr data-id="element-6">
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-7">
              Lead Details
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-8">
              Source
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-9">
              Owner
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-10">
              Current Status
            </th>
            <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-11">
              Reason
            </th>
            <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-12">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-100" data-id="element-13">
          {leads.map(lead => <tr key={lead.id} className="group hover:bg-gray-50 transition-colors" data-id="element-14">
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-15">
                <div className="flex items-center" data-id="element-16">
                  <div className="w-2 h-2 rounded-full mr-3 bg-red-400" data-id="element-17" />
                  <div data-id="element-18">
                    <button onClick={() => onViewDetails(lead, 'Will Be Cancelled')} className="text-sm font-medium text-gray-900 hover:text-indigo-600 transition-colors" data-id="element-19">
                      {lead.name}
                    </button>
                    <div className="text-xs text-gray-500" data-id="element-20">{lead.phone}</div>
                  </div>
                </div>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-21">
                <span className="text-sm text-gray-600" data-id="element-22">{lead.source}</span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-23">
                <span className="text-sm text-gray-600" data-id="element-24">{lead.owner}</span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-25">
                <Badge variant="neutral" data-id="element-26">{lead.status}</Badge>
              </td>
              <td className="px-6 py-4 whitespace-nowrap" data-id="element-27">
                <span className="text-xs text-red-600 bg-red-50 px-2 py-1 rounded-md" data-id="element-28">
                  Status changed to {lead.status}
                </span>
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-29">
                <div className="flex items-center justify-end gap-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-30">
                  <Button variant="ghost" size="sm" className="text-gray-500 hover:text-gray-900" onClick={() => onViewDetails(lead, 'Will Be Cancelled')} title="View Details" data-id="element-31">
                    <EyeIcon className="w-4 h-4" data-id="element-32" />
                  </Button>
                </div>
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}